export const MAPTILER_API_KEY = 'ECOoUBmpqklzSCASXxcu'
